import { setRangeMin } from './helpers';

export const setTotalAreaMin = setRangeMin('total_area');
